import { REFUND_LINE_LABELS, REFUND_STATUSES, type RefundStatus } from '@cuito/types';

/**
 * **订单级**退款状态的显示词（契约 §13.8 的三值；主计划 A8：订单级是机器判定、行级是给人看）。
 *
 * 词面**逐字取自** `REFUND_LINE_LABELS`（Chain A 的单一出处）：同一件事的两个粒度不该有两套说法。
 * **判据不在这里**：`refundStatus` 一律用服务端下发的值，本文件只做「枚举 → 中文」。
 */
export const REFUND_STATUS_LABELS: Record<RefundStatus, string> = {
  NONE: REFUND_LINE_LABELS.NONE,
  PARTIALLY_REFUNDED: REFUND_LINE_LABELS.PARTIAL,
  REFUNDED: REFUND_LINE_LABELS.FULL,
};

/** 徽标样式（`rounded border border-black px-1.5 py-0.5 text-xs font-bold`，出处 `admin/Ledger.tsx:189`） */
export const REFUND_STATUS_CLASS: Record<RefundStatus, string> = {
  NONE: 'border-gray-400 bg-white text-gray-500',
  PARTIALLY_REFUNDED: 'border-black bg-white text-black',
  REFUNDED: 'border-black bg-black text-white',
};

function isRefundStatus(value: string): value is RefundStatus {
  return REFUND_STATUSES.some((known) => known === value);
}

/**
 * 服务端将来新增取值时**显示原文**而不是 `undefined`
 * （与 `StockPage.tsx:52-58` 的 `locationTypeLabel` 同款守卫：强转会静默显示 `undefined`）。
 */
export function refundStatusLabel(status: string): string {
  return isRefundStatus(status) ? REFUND_STATUS_LABELS[status] : status;
}

export function refundStatusClass(status: string): string {
  return isRefundStatus(status) ? REFUND_STATUS_CLASS[status] : 'border-gray-400 bg-white text-gray-500';
}
